var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('color-picker',{attrs:{"theme":"light","color":_vm.color,"colors-default":_vm.palette,"sucker-hide":false,"sucker-canvas":_vm.suckerCanvas,"sucker-area":_vm.suckerArea},on:{"changeColor":_vm.changeColor,"openSucker":_vm.openSucker}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }